import React from "react";
import { Box, Divider, Spacer, Stack, Typography } from "../";

import { Theme } from "@sloth-system/styled-utils";
import { TaskStatusEnum } from "digiwash-core";

enum TaskTypeEnum {
  collection = "collection",
  delivery = "delivery",
}

interface LogesticTaskInOrder {
  id: number;
  address_text: string;
  period: Period;
  task_type: TaskTypeEnum;
  status: TaskStatusEnum;
  address_longitude: number;
  address_latitude: number;
  driver?: Driver;
}
interface Driver {
  id: number;
  first_name: string;
  last_name: string;
  cellphone: string;
}

interface Period {
  id: number;
  date: Date;
  title: string;
  start: string;
  end: string;
}
interface LogisticTaskType {
  data: LogesticTaskInOrder;
  footer?: React.ReactNode;
  taskLink?: string;
  theme: Theme;
  active?: boolean;
  line?: boolean;
}

function LogisticTask(props: LogisticTaskType) {
  let isPishkhan = !!props.taskLink;
  return (
    <Box style={{ width: "100%" }}>
      <Stack alignment="stretch" style={{ width: "100%" }}>
        <Spacer size="m" />
        <Box
          pl="l"
          pb={props.data.task_type === "collection" ? "xxl" : ""}
          style={{ width: "100%" }}
        >
          <Typography color="text.light950">
            {props.data.task_type === "collection" ? "جمع آوری" : "تحویل"}
          </Typography>
          <Divider size="m" />
          {!!props.data.address_latitude &&
          !!props.data.address_longitude &&
          isPishkhan ? (
            <a
              target="_blank"
              href={`https://www.google.com/maps/place/${props.data.address_latitude},${props.data.address_longitude}`}
            >
              <Stack>
                <Typography ff="mainBold" numberOfLines={100}>
                  {props.data.address_text}
                </Typography>
              </Stack>
            </a>
          ) : (
            <Stack>
              <Typography ff="mainBold" numberOfLines={100}>
                {props.data.address_text}
              </Typography>
            </Stack>
          )}
          {props.data.period.title ? (
            <>
              <Divider size="m" />
              <Typography color="text.light950">
                {props.data.period.title}
              </Typography>
            </>
          ) : null}
          {props.footer && (
            <>
              <Divider size="m" />
              {props.footer}
            </>
          )}
        </Box>
      </Stack>
    </Box>
  );
}

export default LogisticTask;
